module.exports = __webpack_public_path__ + "media/images/10,000_doctors-66277fba817f298734ce25f9075018bf.svg";